import { Icon } from '@iconify/react';
import { Button, ButtonGroup, Tooltip } from '@nextui-org/react';
import React from 'react';

interface ViewToggleProps {
  viewType: 'tile' | 'list';
  onChange: (view: 'tile' | 'list') => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewType, onChange }) => {
  return (
    <ButtonGroup variant="flat" size="sm">
      <Tooltip content="Grid View">
        <Button
          isIconOnly
          onClick={() => onChange('tile')}
          className={viewType === 'tile' ? 'bg-default-300 ' : ''}
        >
          <Icon icon="zondicons:view-tile" width="15" />
        </Button>
      </Tooltip>
      <Tooltip content="List View">
        <Button
          isIconOnly
          onClick={() => onChange('list')}
          className={viewType === 'list' ? 'bg-default-300 ' : ''}
        >
          <Icon icon="solar:list-bold" width="20" />
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
};

export default ViewToggle;
